// Pure availability rule for the booking « Choix des boissons » step (moved
// out of step-drinks.vue). backend/src/order-edit/drink-eligibility.ts is a
// copy for the order-edit rules; eligibility-cases.json keeps the two in step.

/** The keg: offered only when La Salle (`dinerlasalle`) is booked, split included. */
export const KEG_DRINK_ID = 'futvaldieu';

export interface DrinkOfferContext {
  /** Meal headcount (the diner or noon service quantity). */
  headcount: number;
  /** True when La Salle is booked. */
  hasSalle: boolean;
}

/**
 * The catalog's « Personnes minimum » as a number. An empty/absent value (or
 * the "--" trailing pad) means no minimum: parseInt gives NaN, and NaN <= n is
 * always false, which would otherwise silently hide the product.
 */
export function minimumPersonsOf(
  raw: string | number | null | undefined,
): number {
  return parseInt(String(raw ?? ''), 10) || 0;
}

export function isDrinkOffered(
  drink: { id: string; minimumPersons: number },
  ctx: DrinkOfferContext,
): boolean {
  if (drink.id === KEG_DRINK_ID && !ctx.hasSalle) return false;
  return drink.minimumPersons <= ctx.headcount;
}
